import { Bar } from "react-chartjs-2";
import { Fragment, useEffect, useState } from "react";
import { Child, Container, Header, LayerContent } from "../style";
import { TableContainer } from "../../../Users/User.style";
import { ChartContainer, NoData } from "../../style";
import { useAnalyticsWrapper } from "../../../../../store/store";
import useAnalytics from "../../../../../hooks/useAnalytics";
import moment from "moment";
import {
  barOptions,
  getMetrics,
  doTransformData,
  woundIncidentUnitPlaceCols,
  handlePointClicked,
  transformDataForBarChart,
  prepareTableData,
  prepareChartData
} from "../formUtils";
import CustomerLoader from "../../../../../components/CustomLoader";
import SectionModal, { DefaultContainer } from "../../wound-analysis/sections/SectionModal";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../../utils/helpers/pdfCsvUtils";
import { woundAnalysisDetailCols } from "../../dummyData/colums";
import { Grid, GridColumn, GridColumnProps } from '@progress/kendo-react-grid';
import { CenteredWholeNumCell, HeaderCenteredCell } from "../../../../../components/DynamicGrid/customCells";
import { TotalRow } from "../../../../../components/DynamicGrid/customRows";
import { set } from "lodash";

const bodyAreaAnalysis = ({
  setClickedIncident,
  isFetchingSelectedIncident,   
}: any) => {
  const [tableData, setTableData] = useState<any>([]);
  const [grid, setGrid] = useState<any>([]);    
  const [barData, setBarData] = useState<any>([]);
  const [location, setLocation] = useState("");
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [areaDetails, setAreaDetails] = useState<any>([]);

  const { startDate, endDate, woundFacility, woundAnalysisIncidents } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    woundFacility: state.woundFacility,
    woundAnalysisIncidents: state.woundAnalysisIncidents
  }));

  type AreaRow = {
    area: string;
    count: number;
  };

  const adjustedTableData = (areaData: any) => {
    let returnData: AreaRow[] = [];
    if (areaData.length) {
      let areaTotal = 0;
      for (let i = 0; i < areaData.length; i++) {

        const row: AreaRow = {
          area: areaData[i].area,
          count: areaData[i].incidentCount,
        };
        returnData.push(row);
        areaTotal += areaData[i].incidentCount;
      }
      const totalRow: AreaRow = {
        area: "Total",
        count: areaTotal,
      };
      returnData.push(totalRow);
    }
    return returnData;
  }

  useEffect(() => {
    if (woundAnalysisIncidents !== undefined) {
      const tempData = woundAnalysisIncidents?.bodyAreaAndLocation.bodyAreaAnalysis;
      const transformedData = adjustedTableData(tempData);
      const transformedBarData = transformDataForBarChart(
        transformedData,
        "area"
      );   
      setTableData(transformedData);
      setBarData(transformedBarData);
      setAreaDetails(woundAnalysisIncidents?.allIncidents);
    }
  }, [woundAnalysisIncidents]);
  
  const title = "Body Area Analysis";

  const handleBarClicked = (chart: any) => {
    if (!chart.length) return;
    const label = handlePointClicked(chart, barData?.labels);
    setShowLocationModal(true);
    setLocation(label);
    const filteredDetails = woundAnalysisIncidents.bodyAreaAndLocation.drillDownByArea[label] || [];
    setAreaDetails(filteredDetails);
  };

  useEffect(() => {
    let cellCountProps = { cells: { data: CenteredWholeNumCell, headerCell: HeaderCenteredCell } };
    const grid = (
      <Fragment>
        <Grid
          data={tableData || []}
          scrollable="none"
          rows={{ data: TotalRow }}
      >
          <GridColumn field="area" title="Area" />
          <GridColumn field="count" title="# of Incidents" {...cellCountProps as GridColumnProps}/>
        </Grid>
      </Fragment>
    );
    setGrid(grid);
  }, [tableData]); 

   return (
    <LayerContent>
      <Header>{title}</Header>
        <Container>
          <Child flex="40%">
            {grid}
          </Child>
          <Child flex="60%">
            <ChartContainer>
              {barData?.labels?.length > 0 ? (
                <Bar options={barOptions(handleBarClicked)} data={barData} />
              ) : (
                <NoData>No Data</NoData>
              )}
            </ChartContainer>
          </Child>
        </Container>
      {showLocationModal ? (
        <SectionModal
          open={showLocationModal}
          facilityName={(woundFacility?.label ?? woundFacility?.[0]?.label)}
          startDate={startDate}
          endDate={endDate}
          closeFn={() => setShowLocationModal(false)}
          resetFn={() => {}}
          isLoading={false}
          tableData={areaDetails}
          tableCols={woundAnalysisDetailCols()}
          title={`${title} - ${location}`}
          getUserCallback={(item: any) => setClickedIncident(item)}
          handlePdfExport={() =>
            handlePDFDownload({
              data: areaDetails,
              columnData: woundAnalysisDetailCols(),
              fileName: (woundFacility?.label ?? woundFacility?.[0]?.label),
              startDate,
              endDate,
              subTitle: `${title} - ${location}`,
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              areaDetails,
              woundAnalysisDetailCols(),
              `${(woundFacility?.label ?? woundFacility?.[0]?.label)} - ${title} - ${location}`
            )
          }
        />
      ) : null}
    </LayerContent>
  );
};

export default bodyAreaAnalysis;